<template>
    <div class="auth-layout">
        <div class="auth-layout--login">
            <meta-logo />
            <slot></slot>
        </div>
        <img src="/images/partfactory-icon.svg" alt="Partfactory" class="bg-logo">
    </div>
</template>

<script>
import MetaLogo from '@partfactory/Shared/Header/MetaLogo';

export default {
    name: 'AuthAdminLayout',
    components: {
        MetaLogo,
    }
};
</script>

